import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=29df9a90&"
import script from "../../services/admin/change-password.js?vue&type=script&lang=js&"
export * from "../../services/admin/change-password.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports